export enum RatingType {
    NO_RATING = 0,
    BAD = 1,
    NOT_GOOD = 2,
    GOOD = 3,
    VERY_GOOD = 4
}